import { useGlobalContext} from '../context'


function Dracula() {
    const { players, index, voteForKill, resetBlood, saveFromBite,
        vote, openWaitingScreen, turns, btn1, btn2, setBtn1, setBtn2 } = useGlobalContext();
    
    let currentPlayer = players[index];
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}(Dracula)</h4>
            <p className='text-center'>The ruler of all vampires.You are a legendary being who reigns the Castlevania territory.Your job here is simple, tear the village down!
            Additionally to the ordinary vampires, you can save your poor vitaminless vampires from dying once and you can once save yourself from a werewolf bite.</p>
            <div className='d-flex'>
                <img src={`./img/${currentPlayer.class}.png`} alt="" />
                <div className='btn-holder'>{
                    players.map((player, index) => {
                        if (player.class === 'vampire' || player.class === 'foolvampire' || player.class === 'dracula')
                            return (<button className='btn btn-danger border' disabled='disabled' key={index}>{player.name}</button>)
                        else 
                            return (<button disabled={vote ? 'disabled' : ''} className={turns === 0 ? 'hidden' : 'btn btn-dark'} onClick={(e) => { voteForKill(index); e.target.classList.add('selected') }} key={index}>{`${player.name}(${player.voteCount})`}</button>)           
                    })
                }
                </div>
            </div>
            <button className={btn1 ? 'btn btn-dracula' : 'hidden'} onClick={(e) => { resetBlood(); setBtn1(false) }}>Save Vampires</button>
            <button className={btn2 ? 'btn btn-dracula' : 'hidden'} onClick={(e) => { saveFromBite(index); setBtn2(false) }}>Save Yourself</button>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default Dracula;